import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "multilevel-select__toggle-label" }
const _hoisted_2 = { class: "multilevel-select__content" }
const _hoisted_3 = ["value", "onClick"]
const _hoisted_4 = ["id"]
const _hoisted_5 = { class: "multilevel-select__back-buttons" }
const _hoisted_6 = { class: "u" }
const _hoisted_7 = ["value", "onClick"]
const _hoisted_8 = ["id"]
const _hoisted_9 = { class: "multilevel-select__back-buttons" }
const _hoisted_10 = { class: "u" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "u" }
const _hoisted_13 = ["value", "onClick"]
const _hoisted_14 = { class: "multilevel-select__add-location" }
const _hoisted_15 = ["id"]
const _hoisted_16 = { class: "multilevel-select__back-buttons" }
const _hoisted_17 = { class: "u" }
const _hoisted_18 = ["onClick"]
const _hoisted_19 = { class: "u" }
const _hoisted_20 = ["onClick"]
const _hoisted_21 = { class: "u" }
const _hoisted_22 = ["value", "onClick"]
const _hoisted_23 = { class: "multilevel-select__add-location" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["multilevel-select", {
			'multilevel-select--expand': $setup.show_dropdown
		}])
  }, [
    _createElementVNode("button", {
      class: "multilevel-select__toggle",
      type: "button",
      onClick: _cache[0] || (_cache[0] = $event => ($setup.show_dropdown = !$setup.show_dropdown))
    }, [
      _createElementVNode("p", _hoisted_1, [
        _createElementVNode("span", null, _toDisplayString($setup.input_label), 1 /* TEXT */)
      ])
    ]),
    _createElementVNode("div", _hoisted_2, [
      ($setup.level_1.length > 0)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("ul", {
              class: _normalizeClass(["multilevel-select__top-select", {
						'multilevel-select__top-select--hidden': $setup.hide_top_select
					}])
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.level_1, (location_1) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: 'location-' + location_1.id
                }, [
                  _createElementVNode("button", {
                    type: "button",
                    value: location_1.id,
                    onClick: $event => ($setup.setLocationValue( location_1.id, ( location_1.children && location_1.children.length > 0 ) ? true : false ))
                  }, _toDisplayString(location_1.title), 9 /* TEXT, PROPS */, _hoisted_3)
                ]))
              }), 128 /* KEYED_FRAGMENT */))
            ], 2 /* CLASS */),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.level_1, (location_1) => {
              return (_openBlock(), _createElementBlock(_Fragment, {
                key: 'location-' + location_1.id
              }, [
                (location_1.children.length > 0)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createElementVNode("ul", {
                        id: 'multilevel-select-child-' + location_1.id,
                        class: _normalizeClass(["multilevel-select__child-select", {
								'multilevel-select__child-select--visible': $setup.visible_child_select === location_1.id
							}])
                      }, [
                        _createElementVNode("li", _hoisted_5, [
                          _createElementVNode("button", {
                            type: "button",
                            class: "multilevel-select__back-button",
                            onClick: _cache[1] || (_cache[1] = $event => ($setup.closeAllLocationLevels()))
                          }, [
                            _createElementVNode("span", _hoisted_6, _toDisplayString(location_1.title), 1 /* TEXT */)
                          ])
                        ]),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(location_1.children, (location_2) => {
                          return (_openBlock(), _createElementBlock("li", {
                            key: 'location-' + location_2.id
                          }, [
                            _createElementVNode("button", {
                              type: "button",
                              value: location_2.id,
                              onClick: $event => ($setup.setLocationValue( location_2.id, ( location_2.children && location_2.children.length > 0 ) ? true : false ))
                            }, _toDisplayString(location_2.title), 9 /* TEXT, PROPS */, _hoisted_7)
                          ]))
                        }), 128 /* KEYED_FRAGMENT */))
                      ], 10 /* CLASS, PROPS */, _hoisted_4),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(location_1.children, (location_2) => {
                        return (_openBlock(), _createElementBlock(_Fragment, {
                          key: 'outer-location-' + location_2.id
                        }, [
                          _createElementVNode("ul", {
                            id: 'multilevel-select-child-' + location_2.id,
                            class: _normalizeClass(["multilevel-select__child-select", {
									'multilevel-select__child-select--visible': $setup.visible_child_select === location_2.id
								}])
                          }, [
                            _createElementVNode("li", _hoisted_9, [
                              _createElementVNode("button", {
                                type: "button",
                                class: "multilevel-select__back-button",
                                onClick: _cache[2] || (_cache[2] = $event => ($setup.closeAllLocationLevels()))
                              }, [
                                _createElementVNode("span", _hoisted_10, _toDisplayString(location_1.title), 1 /* TEXT */)
                              ]),
                              _createElementVNode("button", {
                                type: "button",
                                class: "multilevel-select__back-button",
                                onClick: $event => ($setup.setLocationValue( location_1.id, true ))
                              }, [
                                _createElementVNode("span", _hoisted_12, _toDisplayString(location_2.title), 1 /* TEXT */)
                              ], 8 /* PROPS */, _hoisted_11)
                            ]),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(location_2.children, (location_3) => {
                              return (_openBlock(), _createElementBlock("li", {
                                key: 'location-' + location_3.id
                              }, [
                                _createElementVNode("button", {
                                  type: "button",
                                  value: location_3.id,
                                  onClick: $event => ($setup.setLocationValue( location_3.id, ( location_3.children && location_3.children.length > 0 ) ? true : false ))
                                }, _toDisplayString(location_3.title), 9 /* TEXT, PROPS */, _hoisted_13)
                              ]))
                            }), 128 /* KEYED_FRAGMENT */)),
                            _createElementVNode("li", _hoisted_14, [
                              _createVNode($setup["NewProjectLocationFormComponent"], {
                                "field-handle": "project_location",
                                "form-title": "Add location",
                                "parent-id": location_2.id,
                                "onRefresh:projectLocations": _cache[3] || (_cache[3] = ( value ) => $setup.updateProjectLocations( value ))
                              }, null, 8 /* PROPS */, ["parent-id"])
                            ])
                          ], 10 /* CLASS, PROPS */, _hoisted_8),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(location_2.children, (location_3) => {
                            return (_openBlock(), _createElementBlock("ul", {
                              key: 'outer-location-' + location_3.id,
                              id: 'multilevel-select-child-' + location_3.id,
                              class: _normalizeClass(["multilevel-select__child-select", {
										'multilevel-select__child-select--visible': $setup.visible_child_select === location_3.id
									}])
                            }, [
                              _createElementVNode("li", _hoisted_16, [
                                _createElementVNode("button", {
                                  type: "button",
                                  class: "multilevel-select__back-button",
                                  onClick: _cache[4] || (_cache[4] = $event => ($setup.closeAllLocationLevels()))
                                }, [
                                  _createElementVNode("span", _hoisted_17, _toDisplayString(location_1.title), 1 /* TEXT */)
                                ]),
                                _createElementVNode("button", {
                                  type: "button",
                                  class: "multilevel-select__back-button",
                                  onClick: $event => ($setup.setLocationValue( location_1.id, true ))
                                }, [
                                  _createElementVNode("span", _hoisted_19, _toDisplayString(location_2.title), 1 /* TEXT */)
                                ], 8 /* PROPS */, _hoisted_18),
                                _createElementVNode("button", {
                                  type: "button",
                                  class: "multilevel-select__back-button",
                                  onClick: $event => ($setup.setLocationValue( location_2.id, true ))
                                }, [
                                  _createElementVNode("span", _hoisted_21, _toDisplayString(location_3.title), 1 /* TEXT */)
                                ], 8 /* PROPS */, _hoisted_20)
                              ]),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(location_3.children, (location_4) => {
                                return (_openBlock(), _createElementBlock("li", {
                                  key: 'location-' + location_4.id
                                }, [
                                  _createElementVNode("button", {
                                    type: "button",
                                    value: location_4.id,
                                    onClick: $event => ($setup.setLocationValue( location_4.id, ( location_4.children && location_4.children.length > 0 ) ? true : false ))
                                  }, _toDisplayString(location_4.title), 9 /* TEXT, PROPS */, _hoisted_22)
                                ]))
                              }), 128 /* KEYED_FRAGMENT */)),
                              _createElementVNode("li", _hoisted_23, [
                                _createVNode($setup["NewProjectLocationFormComponent"], {
                                  "field-handle": "project_location",
                                  "form-title": "Add location",
                                  "parent-id": location_3.id,
                                  "onRefresh:projectLocations": _cache[5] || (_cache[5] = ( value ) => $setup.updateProjectLocations( value ))
                                }, null, 8 /* PROPS */, ["parent-id"])
                              ])
                            ], 10 /* CLASS, PROPS */, _hoisted_15))
                          }), 128 /* KEYED_FRAGMENT */))
                        ], 64 /* STABLE_FRAGMENT */))
                      }), 128 /* KEYED_FRAGMENT */))
                    ], 64 /* STABLE_FRAGMENT */))
                  : _createCommentVNode("v-if", true)
              ], 64 /* STABLE_FRAGMENT */))
            }), 128 /* KEYED_FRAGMENT */))
          ], 64 /* STABLE_FRAGMENT */))
        : _createCommentVNode("v-if", true)
    ])
  ], 2 /* CLASS */))
}